import { computed, reactive, readonly, toRefs } from 'vue';
import { roomsApi } from '@/api';
import { setGlobalMessage } from '@/stores/Global';
import { order } from '@/stores/Order';

const state = reactive({
  rooms: [],
  weeks: [],
  selectedRoomId: null,
  selectedTimeCode: null
});

export async function loadData(week) {
  const { success, message, rooms, weeks } = await roomsApi(week);
  if (success) {
    rooms.forEach((room) => {
      for (const day in room.timetable) {
       room.timetable[day].forEach((time) => {
          if (
            order.value &&
            order.value.room_id === room.id &&
            order.value.room_code === time.code
          ) {
            state.selectedRoomId = room.id;
            state.selectedTimeCode = time.code;
            time.selected = true;
          } else if (
            time.selected &&
            time.code === state.selectedTimeCode &&
            time.disabled
          ) {
            state.selectedRoomId = null;
            state.selectedTimeCode = null;
            time.selected = false;
          } else if (time.selected && !state.selectedTimeCode) {
            state.selectedRoomId = room.id;
            state.selectedTimeCode = time.code;
            time.selected = true;
          }
        });
      }
    });

    state.rooms = rooms;
    state.weeks = weeks;
  } else if (!success && message) {
    setGlobalMessage(message);
  }
}

export const rooms = readonly(toRefs(state).rooms);
export const weeks = readonly(toRefs(state).weeks);

export const selectedRoomHash = readonly(toRefs(state).selectedRoomHash);

export function setSelectedRoomId(id) {
  state.selectedRoomId = id;
}

export const selectedTimeCode = readonly(toRefs(state).selectedTimeCode);

export function setSelectedTimeCode(code) {
  state.selectedTimeCode = code;
}

export const selectedRoom = computed(() => {
  const index = state.rooms.findIndex(
    (room) => room.id === state.selectedRoomId
  );
  if (index > -1) {
    return state.rooms[index];
  }

  return null;
});
